"use client";

import dynamic from "next/dynamic";

const ClientOnlyBlogIndex = dynamic(() => import("@/templates/BlogIndex"), {
  ssr: false,
  loading: () => <div className="min-h-[600px]" aria-hidden="true" />,
});

export default ClientOnlyBlogIndex;
